import { ChangeDetectionStrategy, Component, booleanAttribute, input } from '@angular/core';

/** Soort feedback die over een kaart getoond wordt. */
export type HdCardFeedbackKind = 'correct' | 'wrong';

/** Duur van de goed/fout-animatie; de host mag na deze tijd `feedback` weer op `null` zetten. */
export const HD_CARD_FEEDBACK_DURATION_MS = 1500;

/**
 * Goed/fout-feedback rond een kaart in de spelmodi: een groene (goed) of rode
 * (fout) ring rond de geprojecteerde kaart met een opspringende cirkel met
 * vinkje of kruisje. Gedeeld door het Poortenjacht-paneel (memory-modi) en de
 * inkleur-spelmodus van de minis-cheat-sheet, zodat beide dezelfde animatie
 * tonen. De host zet `feedback` en wist het na
 * {@link HD_CARD_FEEDBACK_DURATION_MS}; dit component houdt geen timers.
 *
 * `fadeOut` laat de kaart na de ring licht uitfaden (het paneel schakelt dan
 * door naar de volgende vraag); zonder blijft de kaart volledig zichtbaar.
 */
@Component({
  selector: 'hd-card-feedback',
  templateUrl: './hd-card-feedback.component.html',
  styleUrl: './hd-card-feedback.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.is-correct]': 'feedback() === "correct"',
    '[class.is-wrong]': 'feedback() === "wrong"',
    '[class.is-fading]': 'fadeOut()',
  },
})
export class HdCardFeedbackComponent {
  readonly feedback = input<HdCardFeedbackKind | null>(null);
  readonly fadeOut = input(false, { transform: booleanAttribute });
}
